import { Checkbox, FormControlLabel, Grid, InputAdornment, Paper, TextField } from '@material-ui/core'
import { DateTimePicker } from '@material-ui/pickers';
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react'
import { useStressEntryContext } from './StressEntryContext';
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE } from './constants';
import Autocomplete from '@material-ui/lab/Autocomplete';

export const DMLFields = () => {

    const [formData, setFormData] = useState({
        Ambient_temperature: "",
        Ambient_humidity: "",
        Calibration_date: null as Moment | null,
        Installation_method: "",
        Mounting_hardware: "",
        Test_pressure: "",
        Number_of_test_cycles: "",
        Total_Number_of_test_cycles: "",
        DUT_circuit_check_normal: false,

    });

    const installationOptions = [
        "Corner clamps",
        "Tracker 400mm holes",
        "Tracker 790mm holes",
        "Tracker 400mm clamps",
        "Fixed rack ¼ clamps",
    ];
    const { state, dispatch } = useStressEntryContext();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

    };

    const handleDateChange = (date: Moment | null) => {
        setFormData(prev => ({ ...prev, Calibration_date: date }));
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: checked }));
    };

    useEffect(() => {
        const payload = {
            Calibration_date: formData.Calibration_date
                ? formData.Calibration_date.format("YYYY-MM-DD")
                : "",
            Ambient_temperature: formData.Ambient_temperature ? parseFloat(formData.Ambient_temperature) : null,
            Ambient_humidity: formData.Ambient_temperature ? parseFloat(formData.Ambient_humidity) : null,
            Installation_method: formData.Installation_method,
            Mounting_hardware: formData.Mounting_hardware,





        };
        //     console.log("Auto-updated payload:", payload);
        dispatch({ type: "DML_STRESS_DETAILS", payload });
    }, [formData, dispatch]);

    useEffect(() => {
        if (state.mode === STRESSOR_CHECK_OUT_MODE) {
            const payload = {
                Test_pressure: formData.Test_pressure ? parseFloat(formData.Test_pressure) : null,
                Number_of_test_cycles: formData.Number_of_test_cycles ? parseFloat(formData.Number_of_test_cycles) : null,
                Total_Number_of_test_cycles: formData.Total_Number_of_test_cycles ? parseFloat(formData.Total_Number_of_test_cycles) : null,
                DUT_circuit_check_normal: formData.DUT_circuit_check_normal
            };

            dispatch({ type: "DML_STRESS_OUT_DETAILS", payload });
        }
    }, [formData, dispatch, state.mode]);

    return (
        <div>
            <Paper elevation={3}>
                {state.mode === STRESSOR_CHECK_IN_MODE && state.isDMLTestCheck && (

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ marginTop: 16, marginBottom: 16 }}
                    >
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Ambient_temperature"
                                        label="Ambient temperature"
                                        type="number"
                                        value={formData.Ambient_temperature}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">°C</InputAdornment>
                                            ),
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Ambient_humidity"
                                        label="Ambient humidity"
                                        type='number'
                                        value={formData.Ambient_humidity}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">%RH</InputAdornment>
                                            ),
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <DateTimePicker
                                        label="Calibration Date"
                                        format="YYYY-MM-DD HH:mm"
                                        fullWidth
                                        value={formData.Calibration_date}
                                        onChange={handleDateChange}
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        freeSolo
                                        options={installationOptions}
                                        value={formData.Installation_method}
                                        onChange={(event, newValue) => {
                                            handleChange({
                                                target: {
                                                    name: "Installation_method",
                                                    value: newValue || "",
                                                },
                                            } as React.ChangeEvent<HTMLInputElement>);
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            handleChange({
                                                target: {
                                                    name: "Installation_method",
                                                    value: newInputValue,
                                                },
                                            } as React.ChangeEvent<HTMLInputElement>);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="Installation_method"
                                                label="Installation method"
                                                fullWidth
                                            />
                                        )}
                                    />


                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Mounting_hardware"
                                        label="Mounting hardware"
                                        value={formData.Mounting_hardware}
                                        onChange={handleChange}
                                        fullWidth

                                    />

                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Paper>
            {state.mode === STRESSOR_CHECK_OUT_MODE && state.isDMLTestCheck && (
                <Paper>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="flex-start"
                        spacing={2}
                        style={{ marginTop: 16, marginBottom: 16 }}
                    >
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Test_pressure"
                                        label="Test pressure"
                                        type="number"
                                        value={formData.Test_pressure}
                                        onChange={handleChange}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">Pa</InputAdornment>
                                            ),
                                        }}

                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Number_of_test_cycles"
                                        label="Number of test cycles/min"
                                        type="number"
                                        value={formData.Number_of_test_cycles}
                                        onChange={handleChange}
                                        fullWidth


                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Total_Number_of_test_cycles"
                                        label="Number of test cycles(total)"
                                        type="number"
                                        value={formData.Total_Number_of_test_cycles}
                                        onChange={handleChange}
                                        fullWidth


                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="DUT_circuit_check_normal"
                                                checked={formData.DUT_circuit_check_normal}
                                                onChange={handleCheckboxChange}
                                            />
                                        }
                                        label="DUT circuit check normal"
                                    />

                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>

                </Paper>
            )}
        </div>
    )
}


